import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { FilterSearchingBaseViewModel, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { CampaniaEspecificaService } from '../campaniaespecifica.service';
import { CampaniaEspecificaItemResultsViewModel, FilterSearchingTCampaniaEspecificaViewModel, TCampaniaEspecificaViewModel } from '../campaniaespecifica.types';
import { NavMenuService } from 'src/app/components/core/components/navmenu/navmenu.service';
@Component({
    selector: 'app-campaniaespecifica-wrapper',
    templateUrl: './campaniaespecifica-wrapper.component.html',
    styleUrls: ['./campaniaespecifica-wrapper.component.scss'],
})
export class CampaniaEspecificaWrapperComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    listaCampanias: CampaniaEspecificaItemResultsViewModel | null;

    paises: Tc[];
    modelosCf: Tc[];
    idiomas: Tc[];

    private route = '/mantenimiento/campania';
    payload?: FilterSearchingTCampaniaEspecificaViewModel;

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalService: GlobalService,
        private campaniaEspecificaService: CampaniaEspecificaService,
        private router: Router,
        private navMenuService: NavMenuService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.getLists();
        this.recoverLastSearch();
    }

    private getLists(): void {
        this.getPaises();
        this.getModelosCf();
        this.getIdiomas();
    }

    /**
     * We try to get back the previous search done by the user.
     */
    private recoverLastSearch() {
        this.payload = this.campaniaEspecificaService.getLastSearch();
    }

    /**
     * Invoca a un método global de la API para obtener la lista de países
     * @return void
     */
    private getPaises(): void {
        this.globalService.getAllPaises().subscribe((items: Tc[]) => {
            this.paises = items;
        });
    }

    /**
     * Invoca a un método global de la API para obtener la lista de Modelos CF
     * @return void
     */
    private getModelosCf(): void {
        this.globalService.getModelosCf().subscribe((items: Tc[]) => {
            this.modelosCf = items;
        });
    }

    private getIdiomas(): void {
        this.globalService.getIdioma().subscribe(results => {
            this.idiomas = results;
        });
    }

    /**
     * Respond to the action of searching on campaniaespecifica-filter.
     * It will send the filter to the backend and set the response.
     * @param payload FilterSearchingTCampaniaEspecificaViewModel
     * @param pageNumber number
     * @param asc number
     * @param orderBy string
     * @return void
     */
    onSearch(payload: FilterSearchingTCampaniaEspecificaViewModel): void {
        if (!payload) {
            return;
        }
        this.payload = { ...payload } as FilterSearchingTCampaniaEspecificaViewModel; // To keep a copy to be used in the lazy search (paginator)

        this.campaniaEspecificaService.getList(payload).subscribe((results: CampaniaEspecificaItemResultsViewModel) => {
            this.listaCampanias = results;
            this.searching = true;
        });
    }

    /**
     * It will be invoked when using the paginator
     * @param lazyLoadParams FilterSearchingBaseViewModel
     * @return void
     */
    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingTCampaniaEspecificaViewModel;
        this.onSearch(payload);
    }

    /**
     * Invoked when the user wants to clear the form
     * @return void
     */
    onReset(): void {
        this.searching = false;
        this.listaCampanias = null;
        this.campaniaEspecificaService.clearLastSearch();
        this.navMenuService.clearMenuServiceForCampania();
    }

    /**
     * Redirigimos al formulario de creación de una nueva Campaña Específica
     * @return void
     */
    onAdd(): void {
        // Borramos una posible selección anterior de campaña en el menú
        this.navMenuService.clearMenuServiceForCampania();
        this.router.navigate([this.route + '/create']);
    }

    /**
     * Redirigimos al formulario de edición de la Campaña Específica.
     * Cuando el parámetro sea null, el backend captura el error y se muestra en pantalla.
     * @param itemId number|null
     * @return void
     */
    onEdit(itemId: number | null): void {
        this.router.navigate([this.route + '/edit', itemId]);
    }

    /**
     * Invoked when the user wants to export the result to excel
     * @return void
     */
    onExportExcel(): void {
        this.visibilitySpinner = true;

        let model: FilterSearchingTCampaniaEspecificaViewModel = new FilterSearchingTCampaniaEspecificaViewModel();
        Object.assign(model, this.payload);

        this.campaniaEspecificaService.export(model).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    exportIsAvailable(): boolean {
        return this.listaCampanias?.ResultList ? this.listaCampanias?.ResultList?.length > 0 : false;
    }
}
